import React from 'react';


function GovernanceAndAuthority() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Governance and Authority</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Institutional Role</h2>
            <p className="leading-relaxed mb-4">
              The AI Accountability Standards Council (AASC) operates as an independent technical standards body. It defines, publishes, and maintains the Foundational Control Standards for AI Operators. The Council serves as a neutral custodian of the methodologies required for responsible organization using AI operations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Governance Structure</h2>
            <p className="leading-relaxed mb-4">
              The Council is governed by a Steering Committee comprised of industry practitioners and subject matter experts. This committee oversees the standards development lifecycle, ensuring technical relevance and operational feasibility.
            </p>
            <p className="leading-relaxed">
              Administrative functions are executed by the Secretariat, which manages publication, registry maintenance, and public communication.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Scope of Authority</h2>
            <p className="leading-relaxed mb-4">
              The authority of the AASC is limited to the definition of voluntary technical standards. The Council holds authority over:
            </p>
            <ul className="list-disc pl-5 space-y-2 mt-2">
              <li>The text and requirements of the AASC Standards Framework.</li>
              <li>The semantic versioning and evolution of these standards.</li>
              <li>The definitions of status within the AASC Public Registry.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Limitations of Authority</h2>
            <p className="leading-relaxed mb-4">
              The AASC is not a government regulator or enforcement agency. The Council does not possess subpoena power, nor can it impose civil or criminal penalties.
            </p>
            <p className="leading-relaxed">
              Adherence to AASC standards does not constitute compliance with local, state, or federal laws. Operators remain solely responsible for their legal obligations.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default GovernanceAndAuthority;